<ion-card class="card-common main-card ion-no-margin ion-margin-bottom"
  [class.selected]="selectedIndex === currentIndex()">
  <!-- Card header: registration and notifications -->
  <ion-card-header class="card-header">
    <ion-toolbar class="bg-transparent ion-no-padding pt-2 pb-2">
      <!-- Vehicle registration number -->
      <ion-label slot="start">
        <ion-text class="reg-plate text-dark text-center">
          {{ vehicle()?.reG_NUMBER }}
        </ion-text>
      </ion-label>

      <!-- Notification icon with count -->
      @if(showNotification){
      <ion-button slot="end" fill="clear" class="dashboard-notification position-relative ion-no-margin"
        (click)="goToNotification(vehicle())">
        <ion-icon class="topMenuIcon notification" src="assets/imgs/notification-icon.svg">
        </ion-icon>

        <ion-text class="noti-count position-absolute text-white d-flex justify-content-center">
          {{ vehicle()?.notificationCount ?? 0 }}
        </ion-text>
      </ion-button>
      }

    </ion-toolbar>
  </ion-card-header>

  <!-- Warning banners -->
  @if ( vehicle()?.roadworthY_IND !== 'Y') {
  <div class="warning-container">
    <app-unroadworthy-warning [icnNo]="vehicle()?.icN_NO?.toString() ?? ''">
    </app-unroadworthy-warning>
  </div>
  }

  @if ( vehicle()?.roadworthY_IND === 'Y' && vehicle()?.haS_DEFECTS_IND === 'Y') {
  <div class="warning-container">
    <app-safety-defects-warning [icnNo]="vehicle()?.icN_NO?.toString() ?? ''">
    </app-safety-defects-warning>
  </div>
  }

  <!-- Card content -->
  <ion-card-content>
    <ion-row>
      <!-- Vehicle image -->
      <ion-col sizeXs="12" sizeMd="3" class="d-flex align-items-center justify-content-center">
        <ion-img class="car-image" [src]="getVehicleImage()" [alt]="vehicle()?.vehiclE_IMAGE_TYPE">
        </ion-img>
      </ion-col>

      <!-- Vehicle details -->
      <ion-col sizeXs="12" sizeMd="9" class="right-content text-dark">
        <!-- Make and model -->
        <ion-row class="vehicle-name font-family-bold">
          <ion-col size="12">
            <ion-text>
              {{ vehicle()?.makE_NAME || '-' }}
            </ion-text>

            <div class="fw-normal xswidth360px">
              {{ vehicle()?.modeL_NAME || '-' }}
              {{ vehicle()?.modeL_TRIM }}
            </div>
          </ion-col>
        </ion-row>

        <!-- Odometer information -->
        <ion-row class="odometer-row fw-normal">
          <ion-col [size]="isMobileApp()? 8:4">
            <ion-text>
              {{ 'A_LABEL2' | translate }} :
            </ion-text>
          </ion-col>

          <ion-col [size]="isMobileApp()? 4:8" [ngClass]="isMobileApp() ? 'd-flex justify-content-end' : ''">
            <ion-text class="value">
              {{ vehicle()?.currenT_ODOM | formatNumber }}
            </ion-text>
          </ion-col>
        </ion-row>
      </ion-col>
    </ion-row>

    <!-- Action buttons -->
    @if (showButtons()) {
    <ion-toolbar class="bg-transparent">
      <ion-buttons [slot]="isMobileApp() ? '' : 'end' " class="toolbar-btn-group text-white d-flex align-items-center"
        [ngClass]="{
        'flex-column gap-2': isMobileApp()
      }">
        <!-- Select vehicle -->
        <ion-button class="btn_secondary" [ngClass]="{
          'w-100': isMobileApp()
        }" (click)="selectVehicle()" (keydown.enter)="selectVehicle()">
          @if (selectedIndex === currentIndex()) {
          <ion-icon size="large" color="success" src="assets/imgs/checkmark-outline.svg">
          </ion-icon>
          }

          <ion-text class="text-white">
            {{
            (selectedIndex === currentIndex()
            ? 'BTN_TEXT2'
            : 'BTN_TEXT1') | translate
            }}
          </ion-text>
        </ion-button>

        <!-- Inspect action -->
        @if (isInspect()) {
        <ion-button (click)="navigatePui()" [ngClass]="{
          'w-100 btn_secondary_outline': isMobileApp(),
          'btn_secondary': !isMobileApp()
        }" (keydown.enter)="navigatePui()" routerDirection="root">
          <ion-text [ngClass]="{'text-white': !isMobileApp()}">
            {{ 'BTN_TEXT3' | translate }}
          </ion-text>
        </ion-button>
        }

        <!-- Vehicle details -->
        <ion-button [ngClass]="{
          'w-100 btn_secondary_outline details': isMobileApp(),
          'btn_secondary': !isMobileApp()
        }" routerDirection="root" (click)="navigateVehicleDetails()" (keydown.enter)="navigateVehicleDetails()">
          <ion-text [ngClass]="{'text-white': !isMobileApp()}">
            {{ 'BTN_TEXT4' | translate }}
          </ion-text>
        </ion-button>
      </ion-buttons>
    </ion-toolbar>
    }
  </ion-card-content>

</ion-card>

<!-- Not my vehicle action -->
@if (showNotMyVehicle() && isMobileApp()) {
<ion-button class="btn_secondary ion-no-margin ion-no-padding w-100" (click)="notMyVehicle()"
  (keydown.enter)="notMyVehicle()">
  {{ 'NOT_MY_VEHICLE1' | translate }}
</ion-button>
}
